import type { HipSpineUserPreferencesApiObject } from '@/api/hipSpinePreferences/types';
import type { HipSpineUserPreferenceData } from '@/stores/hipSpinePreferences/types';

export function apiToState(apiData: HipSpineUserPreferencesApiObject): HipSpineUserPreferenceData {
    return {
        minCupAnteversionBound: apiData.min_cup_anteversion_bound,
        maxCupAnteversionBound: apiData.max_cup_anteversion_bound,
        minCupInclinationBound: apiData.min_cup_inclination_bound,
        maxCupInclinationBound: apiData.max_cup_inclination_bound,
    };
}

export function stateToRequest(
    state: HipSpineUserPreferenceData,
): HipSpineUserPreferencesApiObject {
    return {
        min_cup_anteversion_bound: state.minCupAnteversionBound!,
        max_cup_anteversion_bound: state.maxCupAnteversionBound!,
        min_cup_inclination_bound: state.minCupInclinationBound!,
        max_cup_inclination_bound: state.maxCupInclinationBound!,
    };
}
